import styled from 'styled-components';
import DateFormatted from '@components/dateFormatted/DateFormatted';
import Badge from '@components/Badge';

const ProjectTitle = styled.h2`
	font-size: 15px;
	font-weight: 700;
	margin-bottom: 4px;
`;

const Description = styled.p`
	font-size: 11px;
	color: ${({ theme }) => theme.colors.textAccent};
	margin-bottom: 8px;
`;

const TagsRow = styled.div`
	margin-bottom: 8px;
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
`;

const InfoRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 6px;
`;

const InfoItem = styled.div`
	margin-bottom: 8px;
`;

const Label = styled.label`
	display: block;
	font-size: 10px;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	color: ${({ theme }) => theme.colors.textAccent};
	opacity: 0.8;
	margin-bottom: 1px;
`;

const Value = styled.div`
	font-size: 12px;
	color: rgba(255, 255, 255, 0.95);
`;

const ProjectSection = ({ project }) => {
	if (!project) return null;

	return (
		<>
			<InfoItem>
				<Label>Title</Label>
				<ProjectTitle>{project.title || '-'}</ProjectTitle>
			</InfoItem>
			{project.description && (
				<InfoItem>
					<Label>Description</Label>
					<Description>{project.description}</Description>
				</InfoItem>
			)}
			{project.tags?.length > 0 && (
				<InfoItem>
					<Label>Tags</Label>
					<TagsRow>
						{project.tags.map((tag, i) => (
							<Badge key={i}>{tag}</Badge>
						))}
					</TagsRow>
				</InfoItem>
			)}
			<InfoRow>
				<InfoItem>
					<Label>Mode</Label>
					<Value>{project.image_mode || 'Video'}</Value>
				</InfoItem>
				<InfoItem>
					<Label>Created</Label>
					<Value>
						{project.created_at ? (
							<DateFormatted
								inputDate={project.created_at}
								dateFormat="MMM d, yyyy h:mm a"
							/>
						) : (
							'-'
						)}
					</Value>
				</InfoItem>
			</InfoRow>
		</>
	);
};

export default ProjectSection;
